import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { FullHeightContainer } from "../../Common/views/FullHeightContainer";
import { HeaderConfig } from "../../Header/views/HeaderConfig";
import { useSelectedOrganization } from "../../Organizations/hooks/useSelectedOrganization";
import { useT } from "../../Translation/hooks/useT";
import { useNotifications } from "../hooks/useNotifications";
import { NotificationsCollectionListView } from "./NotificationsCollectionListView";
import { NotificationsMarkAllAsReadButton } from "./NotificationsMarkAllAsReadButton";

export const NotificationsUnassignedTasksPage: FC = () => {
  const t = useT();
  const organizationId = useSelectedOrganization((state) => state?.id || null);

  const [, , , unreadNotificationsCount] = useNotifications({
    organizationId,
    userId: null,
    filters: [
      ["hasBeenRead", "==", false],
      ["isTask", "==", true],
    ],
    limit: 1,
    withCount: true,
  });

  if (!organizationId) {
    return null;
  }

  return (
    <>
      <HeaderConfig variant="WITH_NAVIGATION" />
      <FullHeightContainer>
        <Stack py={5} spacing={3}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            spacing={3}
          >
            <Typography variant="h3">
              {t("NotificationsUnassignedTasksPage_Headline_UnassignedTasks")}
            </Typography>

            {organizationId && (
              <NotificationsMarkAllAsReadButton
                organizationId={organizationId}
                isDisabled={!unreadNotificationsCount}
                isAssigned={false}
                isTask
              />
            )}
          </Stack>
          <NotificationsCollectionListView
            organizationId={organizationId}
            userId={null}
            filters={[["isTask", "==", true]]}
          />
        </Stack>
      </FullHeightContainer>
    </>
  );
};
